import module from 'contabilidad/catalogosexternos/module'
import template from './template.html'

export class sucursalesItemConfirmarComponent{

  data
  familias
  accion
  text
  numeroCuenta
  idSucursal
  familiasLength
  onClose = undefined
  familiasLength

  constructor(CatalogosExternosSucursalCuentasContables){
    this.CatalogosExternosSucursalCuentasContablesService = CatalogosExternosSucursalCuentasContables
  }

  continuar(){
    if(this.accion === 'INICIALIZAR') {
      this.inicializar();
    }else if(this.accion === 'EDITAR'){
      this.editar();
    }
  }

  finalizar() {
    if(this.accion === 'INICIALIZAR'){
      location.reload();
    }
    this.onClose();
  }

  editar(){
    if(this.procesando){
      return
    }
    
    if(this.verDuplicado()){
      this.error = '2 familias tienen la misma cuenta contable.'
      throw new Error('2 familias tienen la misma cuenta contable.')
    }

    this.procesando = true;
    this.promise = this.CatalogosExternosSucursalCuentasContablesService.put(this.data)
    .then(() => (this.finalizado = true))
    .catch((error) => (this.error = error.data || error))
    .finally(() => (this.procesando = false))
  }

  inicializar(){
    if(this.procesando){
      return
    }

    this.procesando = true;

    this.promise = this.CatalogosExternosSucursalCuentasContablesService.post(this.crearCuentasContables())
    .then(() => (this.finalizado = true))
    .catch((error) => (this.error = error.data || error))
    .finally(() => (this.procesando = false))
  }

  crearCuentasContables(){
    let data = [];
    this.familiasLength = parseInt(Object.keys(this.familias).length)
  
    for(let i = 0; i < this.familiasLength; i++){
      //Familias que se salta
      if(i==12 || i==15 || i==17){i++}
      
      let familia = (i+1).toLocaleString(undefined, {minimumIntegerDigits: 2})
      data.push({
          id_sucursal: this.idSucursal,
          id_familia: i+1,
          cuenta_contable: `115${this.numeroCuenta}${familia}000000`,
          status: 1 
      })
    }
    return data;
  }

  verDuplicado(){
    let cuentas_contables = this.data.map((x) => x.cuentaContable);
    let duplicado = false;
    cuentas_contables.sort()

    for(let i=0; i<cuentas_contables.length; i++){
      if(cuentas_contables[i] == cuentas_contables[i+1]) duplicado = true;
    }

    return duplicado
  }
}

module.component('contabilidadCatalogosexternosSucursalesConfirmar', {
  template,
  bindings: {
    accion: '<',
    text: '<',
    data: '<',
    familias: '<',
    numeroCuenta: '<',
    idSucursal: '<',
    onClose: '&'
  },
  controller: sucursalesItemConfirmarComponent,
})


// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/components/sucursales/confirmar/component.js